import { render, staticRenderFns } from "./left-side-bar.vue?vue&type=template&id=52bf5c6c&scoped=true&"
import script from "./left-side-bar.vue?vue&type=script&lang=js&"
export * from "./left-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./left-side-bar.vue?vue&type=style&index=0&id=52bf5c6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf5c6c",
  null
  
)

export default component.exports